<template>
  <div class="activity-section">
    <h5 class="section-heading d-flex justify-content-between align-items-center" style="cursor: pointer;"
      @click="isSectionExpanded = !isSectionExpanded">
      <span>
        {{ title }}
        <i :class="[iconClass, 'text-primary', 'ms-2']"></i>
      </span>
      <span class="d-flex align-items-center">
        <span class="badge bg-light text-primary me-2 font-size-12" v-if="activities && activities.length">
          {{ activities.length }} hoạt động
        </span>
        <i :class="['fas', isSectionExpanded ? 'fa-chevron-up' : 'fa-chevron-down', 'text-secondary']"></i>
      </span>
    </h5>

    <b-collapse :visible="isSectionExpanded">
      <div v-if="isSectionExpanded">
        <p class="text-muted small mb-3 mt-2">{{ description }}</p>

        <!-- KHU VỰC LẶP QUA CÁC HOẠT ĐỘNG CON -->
        <div v-for="(activity, index) in activities" :key="activity.id" class="sub-activity-card mb-3 p-3 shadow-sm">
        <!-- STT VÀ NÚT XÓA/DI CHUYỂN -->
        <div class="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
          <div class="d-flex align-items-center">
            <span class="fw-bold text-primary">Hoạt động {{ index + 1 }}
              <button type="button" class="btn btn-sm btn-link text-primary ms-3 p-0" @click="toggleExpand(activity.id)"
                title="Mở rộng/Thu gọn chi tiết">
                {{ activity.isExpanded ? "Thu gọn" : "Mở rộng" }}
                <i :class="[
                  'fas',
                  activity.isExpanded ? 'fa-chevron-up' : 'fa-chevron-down',
                ]"></i>
              </button>
              <p class="text-muted" v-if="activity.name">
                {{ activity.name }}
              </p>
              <p class="text-muted" v-if="activity.ngayBatDau || activity.ngayBatDauShow">
                {{ formatActivityDate(activity.ngayBatDau || activity.ngayBatDauShow) }} Lúc
                {{ activity.gioBatDau }}
                {{ activity.gioKetThuc ? " - " + activity.gioKetThuc : "" }}
              </p>
            </span>
          </div>
          <div class="row">
            <div class="control-buttons">
              <!-- Nút Lên -->
              <button type="button" class="btn btn-sm btn-outline-secondary me-2" @click="moveUp(index)"
                :disabled="index === 0" title="Di chuyển lên">
                <i class="fas fa-arrow-up"></i>
              </button>
              <!-- Nút Xuống -->
              <button type="button" class="btn btn-sm btn-outline-secondary me-2" @click="moveDown(index)"
                :disabled="index === activities.length - 1" title="Di chuyển xuống">
                <i class="fas fa-arrow-down"></i>
              </button>
              <!-- Nút Xóa -->
              <button type="button" class="btn btn-sm btn-danger" @click="handleShowDeleteModal(activity.id)"
                title="Xóa hoạt động">
                <i class="fas fa-trash-alt"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- NỘI DUNG CHI TIẾT (SỬ DỤNG B-COLLAPSE) -->
        <b-collapse :visible="activity.isExpanded" :id="`activity-collapse-${activity.id}`">
          <div v-if="activity.isExpanded" class="row pt-2">
            <div class="col-md-6 mb-3">
              <label class="form-label">Tên hoạt động (Tiếng Việt)</label>
              <input v-model="activity.name" class="form-control form-control-sm" placeholder="Nhập tên hoạt động" />
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Tên hoạt động (Tiếng Anh)</label>
              <input v-model="activity.nameEn" class="form-control form-control-sm" placeholder="Enter activity name" />
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Địa điểm (Tiếng Việt)</label>
              <input v-model="activity.diaChi" class="form-control form-control-sm" placeholder="Địa điểm diễn ra" />
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Địa điểm (Tiếng Anh)</label>
              <input v-model="activity.diaChiEn" class="form-control form-control-sm" placeholder="Enter location" />
            </div>

            <!-- Cột Ngày Bắt Đầu -->
            <div class="col-md-3 mb-3">
              <label class="form-label">Ngày Bắt đầu</label>
              <input :value="formatDateForInput(activity.ngayBatDau)" @input="
                updateActivityDate($event.target.value, activity, 'ngayBatDau')
                " type="date" class="form-control form-control-sm" />
            </div>

            <!-- Cột Ngày Kết Thúc -->
            <div class="col-md-3 mb-3">
              <label class="form-label">Ngày Kết thúc</label>
              <input :value="formatDateForInput(activity.ngayKetThuc)" @input="
                updateActivityDate($event.target.value, activity, 'ngayKetThuc')
                " type="date" class="form-control form-control-sm" />
            </div>

            <!-- Cột Giờ Bắt Đầu -->
            <div class="col-md-3 mb-3">
              <label class="form-label">Giờ Bắt đầu</label>
              <input v-model="activity.gioBatDau" type="time" class="form-control form-control-sm"
                placeholder="HH:MM" />
            </div>

            <!-- Cột Giờ Kết Thúc -->
            <div class="col-md-3 mb-3">
              <label class="form-label">Giờ Kết thúc</label>
              <input v-model="activity.gioKetThuc" type="time" class="form-control form-control-sm"
                placeholder="HH:MM" />
            </div>

            <!-- Chủ trì -->
            <div class="col-md-3 mb-3">
              <label class="form-label">Chủ trì (Tiếng Việt)</label>
              <input v-model="activity.chuTri" class="form-control form-control-sm" placeholder="Cơ quan chủ trì" />
            </div>
            <div class="col-md-3 mb-3">
              <label class="form-label">Chủ trì (Tiếng Anh)</label>
              <input v-model="activity.chuTriEn" class="form-control form-control-sm" placeholder="Organizer/Host" />
            </div>

            <!-- Tham mưu -->
            <div class="col-md-3 mb-3">
              <label class="form-label">Tham mưu (Tiếng Việt)</label>
              <input v-model="activity.thamMuu" class="form-control form-control-sm" placeholder="Cơ quan tham mưu" />
            </div>
            <div class="col-md-3 mb-3">
              <label class="form-label">Tham mưu (Tiếng Anh)</label>
              <input v-model="activity.thamMuuEn" class="form-control form-control-sm" placeholder="Advisor" />
            </div>

            <!-- Đại biểu -->
            <div class="col-md-3 mb-3">
              <label class="form-label">Đại biểu (Tiếng Việt)</label>
              <input v-model="activity.daiBieu" class="form-control form-control-sm"
                placeholder="Thành phần đại biểu" />
            </div>
            <div class="col-md-3 mb-3">
              <label class="form-label">Đại biểu (Tiếng Anh)</label>
              <input v-model="activity.daiBieuEn" class="form-control form-control-sm" placeholder="Delegates" />
            </div>

            <!-- Phối hợp -->
            <div class="col-md-3 mb-3">
              <label class="form-label">Phối hợp (Tiếng Việt)</label>
              <input v-model="activity.phoiHop" class="form-control form-control-sm" placeholder="Cơ quan phối hợp" />
            </div>
            <div class="col-md-3 mb-3">
              <label class="form-label">Phối hợp (Tiếng Anh)</label>
              <input v-model="activity.phoiHopEn" class="form-control form-control-sm" placeholder="Collaborator" />
            </div>

            <!-- Quy mô -->
            <div class="col-md-3 mb-3">
              <label class="form-label">Quy mô (Tiếng Việt)</label>
              <input v-model="activity.quyMo" class="form-control form-control-sm"
                placeholder="Ví dụ: Cấp tỉnh, Cấp huyện..." />
            </div>
            <div class="col-md-3 mb-3">
              <label class="form-label">Quy mô (Tiếng Anh)</label>
              <input v-model="activity.quyMoEn" class="form-control form-control-sm"
                placeholder="Scale (Province/District...)" />
            </div>

            <!-- Ý tưởng -->
            <div class="col-md-3 mb-3">
              <label class="form-label">Ý tưởng (Tiếng Việt)</label>
              <input v-model="activity.yTuong" class="form-control form-control-sm"
                placeholder="Ý tưởng tổ chức/thiết kế..." />
            </div>
            <div class="col-md-3 mb-3">
              <label class="form-label">Ý tưởng (Tiếng Anh)</label>
              <input v-model="activity.yTuongEn" class="form-control form-control-sm"
                placeholder="Concept details..." />
            </div>

            <!-- Hình thức -->
            <div class="col-md-6 mb-3">
              <label class="form-label mb-1">Hình thức (Tiếng Việt)</label>
              <ckeditor-nuxt :editor="editor" v-model="activity.hinhThuc" :config="editorConfig" />
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label mb-1">Hình thức (Tiếng Anh)</label>
              <ckeditor-nuxt :editor="editor" v-model="activity.hinhThucEn" :config="editorConfig" />
            </div>

            <!-- Cột Tọa độ -->
            <div class="col-md-3 mb-3">
              <label class="form-label">Latitude (Vĩ độ)</label>
              <input v-model="activity.latitude" type="text" class="form-control form-control-sm" />
            </div>
            <div class="col-md-3 mb-3">
              <label class="form-label">Longitude (Kinh độ)</label>
              <input v-model="activity.longitude" type="text" class="form-control form-control-sm" />
            </div>

            <!-- File đính kèm -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Tài liệu / Bản đồ đính kèm (Ảnh, PDF...)</label>
              <div class="d-flex align-items-center gap-2 mt-1">
                <input type="file" class="form-control form-control-sm" @change="handleFileUpload($event, activity)"
                  style="display: none" :id="`file-upload-${activity.id}`" />
                <button type="button" class="btn btn-sm btn-outline-primary" @click="triggerFileUpload(activity.id)">
                  <i class="fas fa-upload me-1"></i> Chọn file đính kèm
                </button>
                <div v-if="activity.file && activity.file.fileId"
                  class="ms-2 text-success small d-flex align-items-center">
                  <i class="fas fa-file-alt me-1 text-success"></i>
                  <a :href="getFileUrl(activity.file)" target="_blank"
                    class="text-success me-2 fw-semibold text-truncate" style="max-width: 150px;">
                    {{ activity.file.fileName }}
                  </a>
                  <button type="button" class="btn btn-sm btn-link text-danger p-0 ms-1" @click="removeFile(activity)"
                    title="Xóa tài liệu">
                    <i class="fas fa-times-circle"></i>
                  </button>
                </div>
              </div>
            </div>

            <!-- Danh sách Nội dung chi tiết (noiDungs) -->
            <div class="col-md-12 mb-3">
              <div class="d-flex justify-content-between align-items-center mb-2 border-bottom pb-1">
                <label class="form-label mb-0 fw-semibold">Nội dung chi tiết</label>
                <button type="button" class="btn btn-sm btn-outline-success py-0 px-2" style="font-size: 11px;"
                  @click="addNoiDung(activity)">
                  <i class="fas fa-plus me-1"></i> Thêm dòng nội dung
                </button>
              </div>

              <div v-if="!activity.noiDungs || activity.noiDungs.length === 0" class="text-muted small">
                Chưa có nội dung chi tiết.
              </div>

              <div v-else class="noi-dung-list">
                <div v-for="(nd, ndIdx) in activity.noiDungs" :key="ndIdx" class="row g-2 align-items-center mb-2">
                  <!-- Input văn bản nội dung (VI) -->
                  <div class="col flex-grow-1">
                    <input v-model="nd.text" class="form-control form-control-sm"
                      placeholder="Nội dung (Tiếng Việt)..." />
                  </div>
                  <!-- Input văn bản nội dung (EN) -->
                  <div class="col flex-grow-1">
                    <input v-model="nd.textEn" class="form-control form-control-sm"
                      placeholder="Nội dung (Tiếng Anh)..." />
                  </div>

                  <!-- Chọn icon -->
                  <div class="col-auto">
                    <select v-model="nd.icon" class="form-select form-select-sm" style="width: 140px;">
                      <option value="info">Info (Thông tin)</option>
                      <option value="chat">Chat (Thảo luận)</option>
                      <option value="star">Star (Trải nghiệm)</option>
                      <option value="music">Music (Nghệ thuật)</option>
                      <option value="calendar">Calendar (Sự kiện)</option>
                    </select>
                  </div>

                  <!-- Nút xóa nội dung -->
                  <div class="col-auto">
                    <button type="button" class="btn btn-sm btn-outline-danger" @click="removeNoiDung(activity, ndIdx)"
                      title="Xóa dòng">
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>

      <b-modal v-model="showDeleteModal" centered title="Xóa hoạt động"
        title-class="modal-delete-title text-danger-custom" no-close-on-backdrop>
        <p class="text-left font-body">Dữ liệu xóa sẽ không được phục hồi!</p>
        <template #modal-footer>
          <button type="button" class="btn-close-form" @click="showDeleteModal = false">
            Đóng
          </button>
          <button type="button" class="btn-del" @click="handleConfirmDelete">
            Xóa
          </button>
        </template>
      </b-modal>
      <!-- MODAL XÓA HOẠT ĐỘNG CON -->
      <!-- <b-modal v-model="showDeleteModal" centered title="Xóa hoạt động" title-class="modal-delete-title"
      no-close-on-backdrop>
      <div class="modal-delete-body">
        <span class="isax isax-danger warning-icon"></span>
        <div>
          <p class="warning-main-text">Hành động này không thể hoàn tác!</p>
          <p class="warning-sub-text">
            Thông tin hoạt động này sẽ hoàn toàn bị xóa khỏi danh sách. Bạn có chắc chắn muốn tiếp tục?
          </p>
        </div>
      </div>

      <template #modal-footer>
        <button type="button" class="btn-cancel-delete" @click="showDeleteModal = false">
          HỦY BỎ
        </button>
        <button type="button" class="btn-confirm-delete" @click="handleConfirmDelete">
          <i class="fas fa-trash-alt me-1"></i> ĐỒNG Ý XÓA
        </button>
      </template>
    </b-modal> -->

        <!-- NÚT THÊM HOẠT ĐỘNG CON -->
        <div class="d-flex justify-content-center mt-3">
          <button type="button" class="btn btn-outline-primary btn-sm" @click="addSubActivity">
            <i class="fas fa-plus me-1"></i> Thêm Hoạt động mới
          </button>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { formatDate } from "../../../utils/time/dateUtils";
import axios from "axios";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

// Template cho một sub-activity mới
const subActivityTemplate = () => ({
  id: "new-" + Date.now() + Math.random(), // ID tạm thời cho Vue key
  name: null,
  nameEn: null,
  ngayBatDau: null,
  ngayKetThuc: null,
  gioBatDau: null,
  gioKetThuc: null,
  diaChi: null,
  diaChiEn: null,
  latitude: "",
  longitude: "",
  chuTri: "",
  chuTriEn: "",
  thamMuu: "",
  thamMuuEn: "",
  daiBieu: "",
  daiBieuEn: "",
  phoiHop: "",
  phoiHopEn: "",
  file: { fileId: null, fileName: null, ext: null, path: null },
  noiDungs: [],
  isExpanded: true,
  quyMo: null,
  quyMoEn: null,
  yTuong: null,
  yTuongEn: null,
  hinhThuc: null,
  hinhThucEn: null,
});

export default {
  name: "ActivitySection",
  components: {
    "ckeditor-nuxt": CKEditor.component,
  },
  props: {
    title: String,
    iconClass: String,
    description: String,
    // Sử dụng .sync để cập nhật mảng hoạt động từ component cha
    activities: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      formatDate: formatDate,
      showDeleteModal: false,
      deletedId: null,
      isSectionExpanded: false,
      editor: ClassicEditor,
      editorConfig: {
        toolbar: {
          items: [
            "bold",
            "italic",
            "link",
            "|",
            "undo",
            "redo",
            "blockQuote",
            "imageUpload",
          ],
          shouldNotGroupWhenFull: false,
        },
        removePlugins: ["Title", "ImageCaption", "MediaEmbedToolbar"],
        simpleUpload: {
          uploadUrl: (process.env.VUE_APP_API_URL || "/api/") + "filesminio/uploadCK",
          headers: {
            Authorization: "optional_token",
          },
        },
      },
    };
  },
  methods: {
    formatDateForInput(dateString) {
      if (!dateString) return "";
      // Lấy phần yyyy-MM-dd từ chuỗi ISO (2025-12-27T00:00:00Z)
      return dateString.split("T")[0];
    },

    // Định dạng ngày hiển thị (hỗ trợ cả yyyy-MM-dd và DD/MM/YYYY)
    formatActivityDate(dateVal) {
      if (!dateVal) return "";
      const match = String(dateVal).match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (match) {
        return `${match[3]}/${match[2]}/${match[1]}`;
      }
      return formatDate(dateVal) || dateVal;
    },

    // NEW: Hàm cập nhật ngày khi người dùng thay đổi
    updateActivityDate(value, activity, field) {
      // Giá trị từ input luôn là yyyy-MM-dd
      activity[field] = value;

      // Đồng bộ ngayBatDauShow / ngayKetThucShow để nhất quán dữ liệu hiển thị và payload gửi lên server
      if (value) {
        const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (match) {
          activity[field + 'Show'] = `${match[3]}/${match[2]}/${match[1]} 00:00:00`;
        }
      } else {
        activity[field + 'Show'] = null;
      }

      // Emit sự kiện để thông báo component cha cập nhật danh sách và kích hoạt lại phản hồi reactive
      this.$emit('update:activities', [...this.activities]);
    },
    toggleExpand(id) {
      const index = this.activities.findIndex((a) => a.id === id);
      if (index !== -1) {
        const newActivities = [...this.activities];
        // Sử dụng Vue.set để đảm bảo tính reactive cho thuộc tính mới
        this.$set(
          newActivities[index],
          "isExpanded",
          !newActivities[index].isExpanded
        );
        this.$emit("update:activities", newActivities);
      }
    },
    // Thêm hoạt động con
    addSubActivity() {
      const newActivity = subActivityTemplate();
      // Gửi sự kiện cập nhật mảng lên component cha
      this.$emit("update:activities", [...this.activities, newActivity]);
    },

    handleShowDeleteModal(id) {
      this.deletedId = id; // Lưu lại ID
      this.showDeleteModal = true;
    },
    async handleConfirmDelete() {
      if (!this.deletedId) return;
      // Thực hiện remove sub activity
      const index = this.activities.findIndex((a) => a.id === this.deletedId);
      if (index !== -1) {
        const newActivities = [...this.activities];
        newActivities.splice(index, 1);
        this.$emit("update:activities", newActivities);
      }
      this.showDeleteModal = false;
      this.deletedId = null;
    },
    // Xóa hoạt động con
    removeSubActivity(index) {
      const newActivities = [...this.activities];
      newActivities.splice(index, 1);
      this.$emit("update:activities", newActivities);
    },

    // Di chuyển item lên
    moveUp(index) {
      if (index > 0) {
        const arr = [...this.activities];
        // Swap items
        [arr[index - 1], arr[index]] = [arr[index], arr[index - 1]];
        this.$emit("update:activities", arr); // Gửi mảng đã sắp xếp
      }
    },

    // Di chuyển item xuống
    moveDown(index) {
      if (index < this.activities.length - 1) {
        const arr = [...this.activities];
        // Swap items
        [arr[index], arr[index + 1]] = [arr[index + 1], arr[index]];
        this.$emit("update:activities", arr); // Gửi mảng đã sắp xếp
      }
    },

    // Quản lý file đính kèm
    triggerFileUpload(activityId) {
      const el = document.getElementById(`file-upload-${activityId}`);
      if (el) {
        el.click();
      }
    },

    async handleFileUpload(event, activity) {
      if (event.target && event.target.files.length > 0) {
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append("files", file);

        let loader = null;
        if (this.$loading) {
          loader = this.$loading.show({
            target: event.target.closest(".sub-activity-card"),
          });
        }

        try {
          const response = await axios.post(`${process.env.VUE_APP_API_URL}filesminio/Upload`, formData);
          const resultData = response.data;
          if (resultData.code === 0) {
            activity.file = {
              fileId: resultData.data.fileId,
              fileName: resultData.data.fileName,
              ext: resultData.data.ext,
              path: resultData.data.path,
            };
            this.$store.dispatch("snackBarStore/addNotify", {
              data: { code: 0, message: "Tải tài liệu đính kèm thành công!" }
            });
          } else {
            this.$store.dispatch("snackBarStore/addNotify", {
              data: { code: resultData.code, message: resultData.message || "Tải tài liệu thất bại" }
            });
          }
        } catch (error) {
          console.error("Error uploading file:", error);
          this.$store.dispatch("snackBarStore/addNotify", {
            data: { code: -1, message: "Lỗi kết nối khi tải tài liệu." }
          });
        } finally {
          if (loader) loader.hide();
        }
      }
    },

    removeFile(activity) {
      activity.file = { fileId: null, fileName: null, ext: null, path: null };
    },

    // Quản lý nội dung chi tiết
    addNoiDung(activity) {
      if (!activity.noiDungs) {
        this.$set(activity, "noiDungs", []);
      }
      activity.noiDungs.push({
        text: "",
        textEn: "",
        icon: "info",
      });
    },

    removeNoiDung(activity, index) {
      activity.noiDungs.splice(index, 1);
    },

    getFileUrl(file) {
      if (!file) return "";
      if (file.path && (file.path.startsWith("http://") || file.path.startsWith("https://"))) {
        return file.path;
      }
      return `${process.env.VUE_APP_API_URL || "/api/"}filesminio/view/${file.fileId || file.path || ""}`;
    },
  },
};
</script>

<style scoped>
.activity-section {
  padding: 15px;
  border: 1px dashed #ccc;
  border-radius: 10px;
}

.section-heading {
  font-weight: 700;
  color: #082957;
  border-bottom: 3px double #eee;
  padding-bottom: 5px;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s ease-in-out;
}

.section-heading:hover {
  color: #007bff;
  border-bottom-color: #007bff;
}

.sub-activity-card {
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  background-color: #fcfcfc;
  transition: all 0.2s;
}

.sub-activity-card:hover {
  border-color: #007bff;
}

/* Nút điều khiển */
.control-buttons button {
  border-radius: 50%;
  width: 30px;
  height: 30px;
  padding: 0;
  font-size: 0.85rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}
</style>
